const config = {
  /**
   *  @desc List all the roles you wish to use in the app
   *  You have a max of 31 before the bit shift pushes the accompanying integer out of
   *  the memory footprint for an integer
   */
  roles: ['public', 'user', 'admin'],

  /**
   *  @desc Build out all the access levels you want referencing the roles listed above
   *  You can use the "*" symbol to represent access to all roles.

   *  The left-hand side specifies the name of the access level, and the right-hand side
   *  specifies what user roles have access to that access level. E.g. users with user role
   *  'user' and 'admin' have access to the access level 'user'.
   */
  accessLevels: {
    public: '*',
    anon: ['public'],
    user: ['user', 'admin'],
    admin: ['admin'],
  },
};
const routingConfig = {};

/**
 *  @desc Method to build a distinct bit mask for each role
 *  It starts off with "1" and shifts the bit to the left for each element in the
 *  roles array parameter
 */

const buildUserRoles = function buildUserRoles() {
  const { roles } = config;
  let bitMaskStr = '01';
  const userRoles = {};

  roles.forEach((roleName) => {
    const intCode = parseInt(bitMaskStr, 2);
    userRoles[roleName] = {
      bitMask: intCode,
      title: roleName,
    };
    /* jslint bitwise: true */
    bitMaskStr = (intCode * 2).toString(2);
  });
  routingConfig.userRoles = userRoles;
};

buildUserRoles();

/**
 *  @desc This method builds access level bit masks based on the accessLevelDeclaration parameter which must
 *  contain an array for each access level containing the allowed user roles.
 */
const buildAccessLevels = function buildAccessLevels() {
  const accessLevelDeclarations = config.accessLevels;
  const { userRoles } = routingConfig;
  const accessLevels = {};

  Object.entries(accessLevelDeclarations).forEach(([level, value]) => {
    let resultBitMask;
    if (typeof value === 'string') {
      if (value === '*') {
        resultBitMask = Object.keys(userRoles)
          .map(() => '1')
          .join('');

        accessLevels[level] = {
          bitMask: parseInt(resultBitMask, 2),
        };
      } else {
        Logger.error(`Access Control Error: Could not parse "${value}" as access definition for level "${level}"`);
      }
    } else {
      resultBitMask = 0;
      const rolesToApply = Array.isArray(value) ? value : [];
      rolesToApply.forEach((roleName) => {
        const roleEntry = userRoles?.[roleName];
        if (roleEntry) {
          // Use numeric addition because role bitmasks are unique powers of two
          resultBitMask += roleEntry.bitMask;
        } else {
          Logger.error(`Access Control Error: Could not find role "${roleName}" in registered roles while building access for "${level}"`);
        }
      });
      accessLevels[level] = {
        bitMask: resultBitMask,
      };
    }
  });
  routingConfig.accessLevels = accessLevels;
};

buildAccessLevels();

export default routingConfig;
